import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { approveObjectifModificationRequest, fetchManagerPendingObjectifModificationsRequest, rejectObjectifModificationRequest } from "../../../redux/actions/performanceActions";
import "../PerformanceStyles.css";
import { asArray, formatDate, statusTone } from "../Collaborateur/performanceUi";

const filters = [
    { value: "SOUMISE", label: "En attente" },
    { value: "APPROUVEE", label: "Approuvees" },
    { value: "REFUSEE", label: "Refusees" },
];
const fieldsByType = {
    MODIFICATION: [
        ["titre", "Titre", "oldTitre"],
        ["indicateur", "Indicateur", "oldIndicateur"],
        ["typeIndicateur", "Type indicateur", "oldTypeIndicateur"],
    ],
    REVISION: [
        ["performanceCible", "Performance cible", "oldPerformanceCible"],
        ["poids", "Poids", "oldPoids"],
        ["dateFin", "Date echeance", "oldDateFin"],
        ["surperformance", "Surperformance", "oldSurperformance"],
        ["tolerance", "Tolerance", "oldTolerance"],
    ],
};

export default function DemandesModificationManagerPage() {
    const dispatch = useDispatch();
    const { managerPending, loading, error } = useSelector((state) => state.performance.modificationsObjectifs);
    const [filter, setFilter] = useState("SOUMISE");
    const [comments, setComments] = useState({});
    const requests = asArray(managerPending);

    useEffect(() => {
        dispatch(fetchManagerPendingObjectifModificationsRequest());
    }, [dispatch]);

    const filtered = useMemo(() => requests.filter((request) => (request.status || "SOUMISE") === filter), [requests, filter]);

    const decide = (request, approved) => {
        const payload = { commentaire: comments[request.id] || "" };
        if (approved) dispatch(approveObjectifModificationRequest(request.id, payload));
        else dispatch(rejectObjectifModificationRequest(request.id, payload));
    };

    return (
        <main className="perf-page">
            <header className="perf-header">
                <div>
                    <h1>Demandes de modification</h1>
                    <p>Demandes d'objectifs a traiter par le manager.</p>
                </div>
            </header>
            <section className="perf-toolbar">
                <div className="perf-segmented">
                    {filters.map((item) => (
                        <button key={item.value} type="button" className={filter === item.value ? "active" : ""} onClick={() => setFilter(item.value)}>
                            {item.label}
                        </button>
                    ))}
                </div>
            </section>
            {loading && <div className="perf-state">Chargement des demandes...</div>}
            {error && <div className="perf-state perf-state--error">{error}</div>}
            {!loading && !error && filtered.length === 0 && <div className="perf-state">Aucune demande pour ce filtre.</div>}
            {!loading && !error && filtered.length > 0 && (
                <section className="perf-table-wrap">
                    <table className="perf-table">
                        <thead>
                            <tr>
                                <th>Demandeur</th>
                                <th>Type</th>
                                <th>Changements</th>
                                <th>Statut</th>
                                <th>Date</th>
                                <th>Justification</th>
                                <th>Decision</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((request) => (
                                <tr key={request.id}>
                                    <td>{request.requestedByNom || "-"}</td>
                                    <td>{request.requestType || "MODIFICATION"}</td>
                                    <td>
                                        {(fieldsByType[request.requestType || "MODIFICATION"] || []).map(([field, label, oldField]) => request[field] != null && (
                                            <div key={field}>{label}: {request[oldField] ?? "-"} -> {request[field]}</div>
                                        ))}
                                    </td>
                                    <td><span className={`perf-badge perf-badge--${statusTone(request.status)}`}>{request.status || "SOUMISE"}</span></td>
                                    <td>{formatDate(request.requestedAt)}</td>
                                    <td>{request.justification || "-"}</td>
                                    <td>
                                        <div className="perf-actions perf-actions--table">
                                            <input className="perf-table-input" placeholder="Commentaire" value={comments[request.id] || ""} onChange={(event) => setComments((current) => ({ ...current, [request.id]: event.target.value }))} />
                                            <button className="perf-btn" type="button" onClick={() => setComments((current) => ({ ...current, [request.id]: request.justification || "" }))}>Consulter</button>
                                            <button className="perf-btn perf-btn--primary" type="button" onClick={() => decide(request, true)}>Approuver</button>
                                            <button className="perf-btn" type="button" onClick={() => decide(request, false)}>Refuser</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </section>
            )}
        </main>
    );
}
